import { motion } from "framer-motion";
import { PUBLISHER_IMAGE } from "../data/books";

const MANIFESTO = [
  {
    n: "01",
    title: "Independent",
    body: "No committees, no gatekeepers. Every book is chosen, edited and published because it deserved to exist.",
  },
  {
    n: "02",
    title: "Canadian",
    body: "A CRA-registered publishing house, operating with full transparency from Canada to readers everywhere.",
  },
  {
    n: "03",
    title: "Mindful",
    body: "Adventure, meditation and action — books that slow the world down long enough for you to feel it.",
  },
];

export const Publisher = () => (
  <section id="publisher" data-testid="publisher-section" className="relative overflow-hidden py-32">
    <div
      className="absolute inset-0 bg-cover bg-center bg-fixed"
      style={{ backgroundImage: `url(${PUBLISHER_IMAGE})` }}
      aria-hidden="true"
    />
    <div className="absolute inset-0 bg-[#0C0A09]/88" />

    <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-15%" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-3xl"
      >
        <div className="mb-6 flex items-center gap-4">
          <span className="h-px w-10 bg-[#E63946]" />
          <p className="font-sans text-[10px] font-bold uppercase tracking-[0.4em] text-[#A8A29E]">
            The Publisher
          </p>
        </div>
        <h2 className="font-serif text-4xl font-bold leading-[1.02] tracking-tight md:text-6xl">
          Samkhya Publishing
        </h2>
        <p className="mt-6 font-sans text-base font-light leading-relaxed text-[#C9C5BC] md:text-lg">
          Founded by author Nicholas K F Matte, Samkhya Publishing is a small,
          serious house for big, quiet ideas. Named for one of the oldest
          schools of Indian philosophy, it publishes writing that looks inward
          without ever standing still — from a monk's visions of past and
          future lives, to haiku carved like statues, to stories that circle
          the globe.
        </p>
      </motion.div>

      <div className="mt-20 grid grid-cols-1 gap-px bg-white/10 md:grid-cols-3">
        {MANIFESTO.map((m, i) => (
          <motion.div
            key={m.n}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`manifesto-${m.n}`}
            className="group bg-[#0C0A09] p-10 transition-colors duration-500 hover:bg-[#141210]"
          >
            <p className="font-serif text-5xl font-black text-[#E63946]/25 transition-colors duration-500 group-hover:text-[#E63946]">
              {m.n}
            </p>
            <h3 className="mt-6 font-serif text-2xl font-bold">{m.title}</h3>
            <p className="mt-4 font-sans text-sm font-light leading-relaxed text-[#A8A29E]">
              {m.body}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
